module.exports = function () {
  return new Worker(__webpack_public_path__ + "a1d68651d42e58ce37fd.worker.js");
};